import { Grid, GridProps, styled } from "@mui/material";

const ImageHolder = styled((props: GridProps) => (
    <Grid md={4} item {...props} />
))(({ theme }) => ({
    minHeight: "100vh",
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    background:
        theme.palette.mode == "dark"
            ? "linear-gradient(#13304E, #060F16);"
            : "linear-gradient(#5F96CF, #0F4571);",
    [`${theme.breakpoints.up("md")}`]: {
        display: "flex",
    },
}));

export default function DesktopSideImageView() {
    return (
        <ImageHolder>
            <img src="/images/register-back.webp" alt="test" width="80%" />
        </ImageHolder>
    );
}
